import { ListBase, ListProps, Record, useListContext, usePermissions } from "react-admin";
import React from "react";
import {Button, Card, Table, Space} from "antd";
import {Link} from "react-router-dom";
import SkeletonTable, {SkeletonTableColumnsType} from "@src/components/Common/SkeletonTable";
import {EditOutlined, ArrowLeftOutlined, PlusOutlined} from "@ant-design/icons";
import { spinnerElement } from "../Common/utils";
import PackDashboardTabs from "../Pack/PackDashboard/PackDashboardTabs";

const LLMModelsListView = () => {
    const { ids, data:llmModels, loaded, loading, error } = useListContext();
    const { permissions } = usePermissions();

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Actions',
            render: (text: any, record: any) => (
                <>
                    <Button style={{ marginRight: '5px'}}>
                        <Link to={`/llm_models/${record.id}`}><EditOutlined />{permissions === "ADMIN"?"Edit":"Show"}</Link>
                    </Button>
                </>
            )
        },
    ];

    if (!loaded && !error) {
        return spinnerElement;
    }

    const tableData: Record[] = []
    ids.forEach(id => tableData.push(llmModels[id]));
    
    return (
        <Card className="criclebox tablespace mb-24 pack-card">
            {permissions === "ADMIN" && (
                <div style={{ display: 'flex', gap: '16px', marginBottom: 0, padding: '8px 16px', flexWrap: 'wrap', alignItems: 'flex-end' }}>
                    <div style={{ marginLeft: 'auto' }}>
                        <Link to="/llm_models/create">
                            <Button type='primary' icon={<PlusOutlined />}>Add LLM Model</Button>
                        </Link>
                    </div>
                </div>
            )}
            <SkeletonTable loading={loading} columns={columns as SkeletonTableColumnsType[]}>
                <Table
                    pagination={false}
                    rowKey="name"
                    columns={columns as SkeletonTableColumnsType[]}
                    dataSource={tableData}
                />
            </SkeletonTable>
        </Card>
    )
}


const LLMModelsList = (props: ListProps) => (
    <>
        <PackDashboardTabs />
        <ListBase {...props}>
            <LLMModelsListView />
        </ListBase>
    </>
)


export default LLMModelsList;
